/**
 * The keys every sector module contributes, and nothing else.
 *
 * This layer exists to keep the *vocabulary* independent of the
 * *composition*. `ModuleKey` is derived from these, and a `SectorProfile`
 * holds `readonly ModuleKey[]` — so deriving the vocabulary from `MODULES`
 * instead, which holds profiles, would put `MODULES` inside its own
 * initializer. TypeScript resolves that to `any`, silently widening
 * `ModuleKey` and voiding every guarantee built on it.
 *
 * A module registers its keys here and everything else — profile, packs,
 * roles, widgets — through `MODULES`. Dependencies run one way: keys know
 * nothing, the registry knows the keys.
 */
import { ASSOCIATION_KEYS } from "./association/keys.js";
import { HOSPITALITE_KEYS } from "./hospitalite/keys.js";
export const MODULE_CONTRIBUTED_KEYS = [...ASSOCIATION_KEYS, ...HOSPITALITE_KEYS];
//# sourceMappingURL=keys.js.map